import { LoadingService } from '../../../../shared/services/loading/loading.service';

export const articleTabLoadingService = new LoadingService();
